module.exports = __webpack_public_path__ + "static/media/SalleConference7Thumb.66834b24.jpg";